import { render, staticRenderFns } from "./IconPage.vue?vue&type=template&id=c3ab3538&scoped=true"
import script from "./IconPage.vue?vue&type=script&lang=js"
export * from "./IconPage.vue?vue&type=script&lang=js"
import style0 from "./IconPage.vue?vue&type=style&index=0&id=c3ab3538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ab3538",
  null
  
)

export default component.exports